import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import View from "../../../../assets/img/svg/view.svg"
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg"
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom"
import Pagination from "../../../custom/Pagination";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import { getDMS_ListView, deletemultiDMS, deleteDMS } from "../../../../actions/DMSAction";
import API from "../../../../_helpers/endpointService";
import moment from "moment";

class ListViewDMPS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            ProjectId: 0,
            index:1,
            DMS_ListView: [],
            DownDelete: [],
            isView: false,
            Overtime: false,
            searchData: {
                ProjectId: 0,
                FromDate: "",
                ToDate: "",
                PageNumber: 1,
                PageSize: 100,
                SortBy: 'dateofreporting',
                SortOrder: 'asc'
            },
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isView: true }) : this.setState({ isView: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.setState({})
        this.getSettingsFormat(this.state.ProjectId)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getSettingsFormat = (data) => {
        let apiUrl = API.SETTINGS_PROJECT + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                }
            })
            .catch((error) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dailyman1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dailyman").addClass("d-none");
        $("#Dailyman").removeClass("d-block");
        $("#DMPSL").removeClass("active-color");
        $("#DMPST").removeClass("fw-bolder");
    }
    dataTable = (data, id) => {
        let apiUrl = API.DMS_LISTVIEW + '?projectId=' + id + '&FromDate=' + data.FromDate + '&ToDate=' + data.ToDate + '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder +'&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    destroyDataTable("staffTable")
                    this.props.dispatch({ type: "DMS_LISTVIEW", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isView === false ? false : true  }, { type: 'day', targets: [1] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder]);
                    this.setState({
                        DMS_ListView: response.data,
                    }, () => {
                        this.setState({ Overtime: false })
                        if (this.state.DMS_ListView.Manpower.length > 0) {
                            this.state.DMS_ListView?.Manpower[0].data.map((val, i) => {
                                if (val.VesselManpowerHours > (val.VesselManpower * 10) || val.YardManpowerHours > (val.YardManpower * 10)) {
                                    this.setState({ Overtime: true })
                                }
                            })
                        }
                        applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isView === false ? false : true  }, { type: 'day', targets: [1] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder]);
                    })
                }
                else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
            });

    }
    handleCheckboxChange = (e, x) => {
        const { DownDelete } = this.state;
        if (DownDelete.length == 0) {
            DownDelete.push(x)
        }
        else {
            if (DownDelete && DownDelete.filter((i) => i == x).length == 1) {
                DownDelete.map((i, ind) => (
                    i == x ?
                        DownDelete.splice(ind, 1)
                        : ""
                ))
            } else {
                DownDelete.push(x)
            }
        }
        this.setState({})
        if (DownDelete.length == 1) {
            localStorage.setItem("DMSEditId", DownDelete[0])
        }
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dailyman1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dailyman").removeClass("d-none");
        $("#Dailyman").addClass("d-block");
        $("#DMPSL").addClass("active-color");
        $("#DMPST").addClass("fw-bolder");
        this.state.DMS_ListView = this.props.DMS_ListView;
        this.setState({})
    };
    handleDateChange = (e, node) => {
        this.state.searchData[node] = e.target.value
        this.setState({});
    };
    Search = () => {
        const { dispatch } = this.props;
        this.state.index=1;
        this.state.searchData.SortBy='dateofreporting'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dailymanpowerstatus/addnew")
    };
    EditPage = () => {
        const { DownDelete } = this.state;
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dailymanpowerstatus/edit")
    };
    EditPageClick = (id) => {
        localStorage.setItem("DMSEditId", id)
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dailymanpowerstatus/edit")
    };
    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deletemultiDMS(this.state.DownDelete, this.state.ProjectId)
        $('input[type=checkbox]').prop('checked', false);
    }

    deletemultiDMS = (data, id) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }
        let apiUrl = API.DMS_LISTVIEW + '/ids?' + ids;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({ DownDelete: [] })
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };
    ViewPage = () => {
        this.props.navigate("/dailymanpowerstatus/view")
    };
    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            ProjectId: 0,
            FromDate: "",
            ToDate: "",
            PageNumber: 1,
            PageSize: 100,
            SortBy: 'dateofreporting',
            SortOrder: 'asc'
        };
        this.state.searchData = input;
        this.setState({});
        // this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    handleSort = (data,ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber = 1;
        this.setState({
            index:ind
        });
        this.dataTable(this.state.searchData, this.state.ProjectId);

    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"MAN" + "1"} className=' textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="MAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Daily Manpower Status</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide ml-3 border-top" : "ml-auto scroll-hide ml-3"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isView ?
                        <>
                            {this.state.isMobile ? <table className="dataTable" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center">
                                            <button className={classes.button} disabled={this.state.DownDelete.length == 1 ? false : true} onClick={this.EditPage}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.DownDelete.length == 1 ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                        </td>

                                        <td className="border-right text-center">
                                            <button className={classes.button} disabled={this.state.DownDelete.length > 0 ? false : true} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.DownDelete.length > 0 ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={classes.button} onClick={this.AddNew}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isView > 0 ? '' : '0.5' }}></i>Add New</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                                : <>
                                    <div className="row border-bottom">
                                        <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3 d-flex">
                                            <button className={`${classes.button} pl-3`} disabled={this.state.DownDelete.length == 1 ? false : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.DownDelete.length == 1 ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                            <button className={classes.button} disabled={this.state.DownDelete.length > 0 ? false : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.DownDelete.length > 0 ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                            <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                                <button className={classes.button} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isView > 0 ? '' : '0.5' }}></i>Add New</button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }</>
                        : <></>
                    }

                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 pt-2 d-flex">
                                {this.state.isMobile ? this.state.Overtime ? <>
                                    <button className={classes.Overtime}><h1 style={{ fontSize: '11px' }}>Overtime Exceeds</h1></button>
                                </> : <></> : <> <h6>Daily Manpower Status</h6>
                                    {this.state.Overtime ?
                                        <div className="ml-2">
                                            <button className={classes.Overtime}><h1 style={{ fontSize: '11px' }}>Overtime Exceeds</h1></button>
                                        </div>
                                        :
                                        <></>
                                    }
                                </>
                                }
                            </div>
                            <div className="col-2 pt-2">
                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }}><img src={FilterIcon} />&nbsp;Filter </button>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive pb-3" style={{ width: "100%" }}>
                                <table id="staffTable" className="dataTable">
                                    <thead>
                                        <tr className="">
                                            <th className="border-top border-left" style={{ width: "3px" }}><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-top border-right border-left" style={{ whiteSpace: "nowrap" }}  onClick={() => this.handleSort('dateofreporting',1)}><span className="spandoc-thead" style={{ color: "#000000" }}>Date of Reporting</span></th>
                                            <th className="border-top border-right " style={{ whiteSpace: "nowrap" }}  onClick={() => this.handleSort('vesselmanpower',2)}><span className="spandoc-thead" style={{ color: "#000000" }}>Vessel Manpower</span></th>
                                            <th className="border-top border-right " style={{ whiteSpace: "nowrap" }}  onClick={() => this.handleSort('vesselmanhours',3)}><span className="spandoc-thead" style={{ color: "#000000" }}>Vessel Man Hours</span></th>
                                            <th className="border-top border-right " style={{ whiteSpace: "nowrap" }}  onClick={() => this.handleSort('yardmanpower',4)}><span className="spandoc-thead" style={{ color: "#000000" }}>Yard Manpower</span></th>
                                            <th className="border-top border-right " style={{ whiteSpace: "nowrap" }}  onClick={() => this.handleSort('yardmanhours',5)}><span className="spandoc-thead" style={{ color: "#000000" }}>Yard Man Hours</span></th>
                                            <th className="border-top border-right " style={{ whiteSpace: "nowrap" }}  onClick={() => this.handleSort('totalmanpower',6)}><span className="spandoc-thead" style={{ color: "#000000" }}>Total Manpower</span></th>
                                            <th className="border-top border-right " style={{ whiteSpace: "nowrap" }} onClick={() => this.handleSort('totalmanhours',7)}><span className="spandoc-thead" style={{ color: "#000000" }}>Total Man Hours</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.DMS_ListView?.Manpower && this.props.DMS_ListView?.Manpower.map((item, value) => (<>
                                            {item.data && item.data.map((item, v) => (
                                                <tr>
                                                    <td className="align-middle text-center  border-left">
                                                        <input type="checkbox" disabled={this.state.isView == true ? false : true} style={{ width: "16px", height: "16px" }} onChange={(e) => this.handleCheckboxChange(e, item.Id)} /></td>
                                                    {this.state.isView ?
                                                        <>
                                                            <td className="spandoc-td align-middle text-center border-right border-left color cursorPointer" onClick={() => this.EditPageClick(item.Id)}>{moment(item.DateOfReporting).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                        </>
                                                        :
                                                        <>
                                                            <td className="spandoc-td align-middle text-center border-right  border-left cursorPointer">{moment(item.DateOfReporting).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                        </>}
                                                    <td className="spandoc-td align-middle text-center border-right">{item.VesselManpower}</td>
                                                    <td className="spandoc-td align-middle text-center border-right" style={{ backgroundColor: item.VesselManpowerHours > (item.VesselManpower * 10) ? "#FED19B" : "" }}>{item.VesselManpowerHours}</td>
                                                    <td className="spandoc-td align-middle text-center border-right">{item.YardManpower}</td>
                                                    <td className="spandoc-td align-middle text-center border-right" style={{ backgroundColor: item.YardManpowerHours > (item.YardManpower * 10) ? "#FED19B" : "" }}>{item.YardManpowerHours}</td>
                                                    <td className="spandoc-td align-middle text-center border-right">{item.TotalManpower}</td>
                                                    <td className="spandoc-td align-middle text-center border-right">{item.TotalManHours}</td>
                                                </tr>
                                            ))}
                                        </>))}
                                    </tbody>
                                    <tfoot>
                                        {this.props.DMS_ListView?.Manpower && this.props.DMS_ListView?.Manpower.map((item, value) => (<>
                                            <tr>
                                                <td colSpan={2} align='center' className="border-right border-left border-top"><span className="spanTopBar" style={{ color: "#000000" }}>Total</span></td>
                                                <td className="align-middle border-right border-top text-center spandoc-td "><span className="spanTopBar" style={{ color: "#000000" }}>{item.TotalVesselManpower}</span></td>
                                                <td className="align-middle border-right border-top text-center spandoc-td "><span className="spanTopBar" style={{ color: "#000000" }}>{item.TotalVesselManHours}</span></td>
                                                <td className="align-middle border-right border-top text-center spandoc-td "><span className="spanTopBar" style={{ color: "#000000" }}>{item.TotalYardManpower}</span></td>
                                                <td className="align-middle border-right border-top text-center spandoc-td "><span className="spanTopBar" style={{ color: "#000000" }}>{item.TotalYardManhours}</span></td>
                                                <td className="align-middle border-right border-top text-center spandoc-td "><span className="spanTopBar" style={{ color: "#000000" }}>{item.TotalManpower}</span></td>
                                                <td className="align-middle border-top text-center border-right spandoc-td"><span className="spanTopBar" style={{ color: "#000000" }}>{item.TotalManHours}</span></td>
                                            </tr>
                                        </>
                                        ))}
                                    </tfoot>
                                </table>
                            </div>
                        </div>

                    </div>
                    <div className="modal left fade  pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date of Reporting - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format("DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "FromDate") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date of Reporting - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.ToDate && moment(this.state.searchData.ToDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.ToDate && moment(this.state.searchData.ToDate).format("DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "ToDate") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                {/* <div class="modal-header">
                            <h1><i class="bi bi-exclamation-triangle-fill text-warning"></i></h1>
                            <div>
                                <h5 class="fw-bold">Warning</h5>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. </p>
                            </div>
                        </div> */}
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                        {/* <i class="bi bi-check-circle-fill text-success"></i> */}
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>

                                    </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        DMS_ListView: state.DMSReducer.DMS_ListView || [],
        settings: state.commonReducer.settings || [],
    };
}

ListViewDMPS.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewDMPS))
);

